import './menu_nav.css';
import { CartIcon } from "../../assets/icons/CartIcon";
import { useMenu } from '../../context/MenuContext';
import { MenuNavItem } from '../MenuNavItem/MenuNavItem';
import { useCart } from '../../context/CartContext';

export const MenuNav = () => {
    //HOOKS
    const { menu } = useMenu();
    const { cart, setCartOpen } = useCart();

    return (
        <div className='menunav_container'>
            <div className='nav_container'>
                <div>
                    
                </div>
                <div className='nav'>
                    {
                        menu && menu.sections && menu.sections.map(section => {
                            return (
                                <MenuNavItem section={section} key={'menu_nav_section_' + section.id} />
                            )
                        })
                    }
                </div>
                <div>

                </div>
            </div>
            <div className='actions'>
                <button onClick={() => setCartOpen(true)}>
                    <div className='cart_items_count'>
                        { cart && cart.items.length }
                    </div>
                    <CartIcon />
                </button>
            </div>
        </div>
    );
}
